import React, { useEffect } from "react";
import { ManufactureNewProductViewModel } from "../../viewmodels/production/ManufactureNewProductViewModel";

import { connect } from "react-redux";

import * as actions from "../../store/actions/index";

import { withRouter } from "../../shared/utility";

import SlideOver from "../../components/slideOver/SlideOver";

import ManufactureNewProductForm from "../../components/forms/production/ManufactureNewProductForm";
import EmptyModal from "../../components/modals/EmptyModal";
import ManufacturedProductLabel from "../../components/forms/production/barcode-label/ManufacturedProductLabel";
import {
  USER_DEPARTMENT_CODE,
  USER_TYPE_CODE,
} from "../../shared/userReferenceCodes";

function ManufactureNewProduct(props: any) {
  const { addSnackbar, logout, router } = props;
  const {
    addIngredientToManufacturedProduct,
    makeApiCallToStartManufacturing,
    certifiedByOptions,
    emptyModal,
    getAssemblyItemReceivingByBarcode,
    getCertifiedByOptionsForDropdown,
    getManufacturedProductIngredients,
    getProductsList,
    setEmptyModelOpen,
    setSlideOver,
    slideOver,
    updateManufacturedProduct,
    getReceivingAssemblyItemInStockByName,
    deleteIngredientFromManufacturedProduct,
    addManualEntryForManufacturingProduct,
    getManufacturedProductLabel,
    printLabelDetails,
    employeeOptions,
    getUsersForDropdown,
    fetchRecipesForDropdown,
    recipes,
    fetchRecipeItems,
    selectedRecipe,
    setSelectedRecipe,
    showErrorModal,
    manufacturedProduct,
    claimsOptions,
    getClaimsForDropdown,
    supervisorOptions,
    locationOptions,
    productionRoomOptions,
    getLocationsForDropdown,
    loadProductionRoomsForLocation,
    calculateAmountRequiredForRecipeItems,
    inProcessMonitoringHistory,
    updateInProcessMonitoringHistory,
    previousInProcessMonitoringHistory,
  } = ManufactureNewProductViewModel(logout, addSnackbar);

  useEffect(() => {
    getClaimsForDropdown();
    getCertifiedByOptionsForDropdown();
    getUsersForDropdown(USER_TYPE_CODE.SUPERVISOR, [
      USER_DEPARTMENT_CODE.ALL,
      USER_DEPARTMENT_CODE.PRODUCTION,
    ]);
    getUsersForDropdown(USER_TYPE_CODE.REGULAR, [
      USER_DEPARTMENT_CODE.ALL,
      USER_DEPARTMENT_CODE.PRODUCTION,
    ]);
    fetchRecipesForDropdown();
    getLocationsForDropdown();
  }, []);

  return (
    <div className="qatrace-screen qatrace-module-page">
      <div className="hide-for-print mt-2">
        <ManufactureNewProductForm
          loading={false}
          deleteIngredientFromManufacturedProduct={
            deleteIngredientFromManufacturedProduct
          }
          addIngredientToManufacturedProduct={
            addIngredientToManufacturedProduct
          }
          certifiedByOptions={certifiedByOptions}
          employeeOptions={employeeOptions}
          claimsOptions={claimsOptions}
          getAssemblyItemReceivingByBarcode={getAssemblyItemReceivingByBarcode}
          getManufacturedProductIngredients={getManufacturedProductIngredients}
          getProductsList={getProductsList}
          updateManufacturedProduct={updateManufacturedProduct}
          setEmptyModelOpen={setEmptyModelOpen}
          setSlideOver={setSlideOver}
          getReceivingAssemblyItemInStockByName={
            getReceivingAssemblyItemInStockByName
          }
          makeApiCallToStartManufacturing={makeApiCallToStartManufacturing}
          addManualEntryForManufacturingProduct={
            addManualEntryForManufacturingProduct
          }
          getManufacturedProductLabel={getManufacturedProductLabel}
          recipes={recipes}
          fetchRecipeItems={fetchRecipeItems}
          selectedRecipe={selectedRecipe}
          setSelectedRecipe={setSelectedRecipe}
          showErrorModal={showErrorModal}
          manufacturedProduct={manufacturedProduct}
          supervisorOptions={supervisorOptions}
          locationOptions={locationOptions}
          productionRoomOptions={productionRoomOptions}
          loadProductionRoomsForLocation={loadProductionRoomsForLocation}
          calculateAmountRequiredForRecipeItems={
            calculateAmountRequiredForRecipeItems
          }
          inProcessMonitoringHistory={inProcessMonitoringHistory}
          updateInProcessMonitoringHistory={updateInProcessMonitoringHistory}
          previousInProcessMonitoringHistory={
            previousInProcessMonitoringHistory
          }
          navigate={router.navigate}
        />
      </div>

      <EmptyModal
        childComponent={emptyModal.childComponent}
        open={emptyModal.open}
        setOpen={setEmptyModelOpen}
      />
      <SlideOver
        childComponent={slideOver.childComponent}
        customClass="max-w-7xl"
        slideOver={slideOver}
        setSlideOver={setSlideOver}
      />
      <ManufacturedProductLabel printLabelDetails={printLabelDetails} />
    </div>
  );
}

const mapStateToProps = (state: any) => {
  return {};
};

const mapDispatchToProps = (dispatch: any) => {
  return {
    logout: () => dispatch(actions.logout()),
    addSnackbar: (snackbar: any) => dispatch(actions.addSnackbar(snackbar)),
  };
};

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(ManufactureNewProduct),
);
